import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { CreateOrUpdateLayout, Layout } from '@thro-types/users';

import { AxiosRequestConfig } from 'axios';

import { createLayout, getLayout, updateLayout } from 'api/usersService';

/**
 * A custom hook for all layout related things from the UsersService.
 *
 * @returns DefinedUseQueryResult<Tile[], Error>
 */
export const useLayoutQuery = (config?: AxiosRequestConfig) => {
  // const queryKey = ['layout', config ? JSON.stringify(config.params) : ''];
  const query = useQuery({
    queryKey: ['layout'],
    queryFn: () => {
      const layout = getLayout(config);
      return layout;
    },
    initialData: { defaultTiles: [], systemTiles: [], layout: null }
  });

  return query;
};

export const useLayoutMutation = (config?: AxiosRequestConfig) => {
  const queryClient = useQueryClient();

  const queryKey = ['layout'];
  const creation = useMutation<Layout, Error, CreateOrUpdateLayout>({
    mutationFn: args => {
      return createLayout(args, config);
    },
    onSuccess: data => {
      queryClient.invalidateQueries({ queryKey });
    },
    onError: data => {}
  });
  const update = useMutation<Layout, Error, { id: number; data: CreateOrUpdateLayout }>({
    mutationFn: args => {
      return updateLayout(args.id, args.data, config);
    },
    onSuccess: data => {
      queryClient.invalidateQueries({ queryKey });
    },
    onError: data => {}
  });

  return { creation, update } as const;
};
